/** Formats a byte count as a human-readable MB string, e.g. `12.3 MB`. */
export const formatMegabytes = (bytes: number): string => `${(bytes / (1024 * 1024)).toFixed(1)} MB`;

/** Formats a progress value as a whole-number percentage, e.g. `42%`, clamped to 0-100. */
export const formatPercent = (value: number | null | undefined): string => {
  const safeValue = value === null || value === undefined || !Number.isFinite(value) ? 0 : value;
  const clamped = Math.min(100, Math.max(0, safeValue));
  return `${Math.round(clamped)}%`;
};

/** Formats a seconds duration as `~12 s left` / `~2 min left`, or `undefined` when unknown. */
export const formatEtaSeconds = (etaSeconds: number | null | undefined): string | undefined => {
  if (etaSeconds === null || etaSeconds === undefined || !Number.isFinite(etaSeconds) || etaSeconds < 0) {
    return undefined;
  }
  if (etaSeconds < 60) {
    return `~${Math.max(1, Math.round(etaSeconds))} s left`;
  }
  return `~${Math.round(etaSeconds / 60)} min left`;
};

/** Formats a duration in seconds for a "Saved" summary, e.g. `48 s` or `2 min 5 s`. */
export const formatDurationSeconds = (totalSeconds: number): string => {
  const seconds = Math.max(0, Math.round(totalSeconds));
  if (seconds < 60) {
    return `${seconds} s`;
  }
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return remainingSeconds ? `${minutes} min ${remainingSeconds} s` : `${minutes} min`;
};
